//
//
//
//
//
//
//
//
//

import SysUtils from "@/utils/sysUtils";

export default {
  data() {
    return {
      val: "",
      isFocus: false,
      hovering: false
    };
  },
  props: {
    value: {},
    placeholder: {
      type: String,
      default: "请输入"
    },
    type: {
      type: String,
      default: "text"
    }
  },
  computed: {
    deleteIcon: function() {
      if (this.$root.themeType == "yellow") {
        return require("../assets/theme_yellow/del.png");
      } else {
        return require("../assets/theme_black/del.png");
      }
    }
  },
  methods: {
    /**
     * 手机号输入监听，限制位数最多11位
     */
    _handleMobileInput(e) {
      if (e.target.value.length > 11) {
        this.val = e.target.value.slice(0, 11);
      }
      this._handleInput();
    },
    _handleInput(e) {
      this.$emit("update:value", this.val);
      SysUtils.scrollPageView();
    },
    _handleBlur() {
      this.isFocus = false;
    },
    _handleDelete() {
      this.val = "";
      this.$emit("update:value", this.val);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/CInput.vue